import React, { useState } from "react";
import { Form, Input, Button, Typography, Result } from "antd";
import { MailOutlined, ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

const { Title } = Typography;

const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="26" height="26" rx="7" fill="var(--i-ems-accent)" />
    <path d="M7.5 13.5l3.5 3.5 7.5-8" stroke="#0B1330" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ForgotPassword = () => {
  const { request } = useRequest();
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onFinish = (values) => {
    setSubmitting(true);
    request({
      url: apiPath.forgotPassword,
      method: "POST",
      data: values,
      onSuccess: () => setSent(true),
      onError: () => setSent(true), // same generic outcome regardless — no email enumeration
    }).finally(() => setSubmitting(false));
  };

  return (
    <div className="i-ems-login-page-single">
      <div className="i-ems-login-form-panel">
        <span className="i-ems-login-form-glow-1" />
        <span className="i-ems-login-form-glow-2" />
        <div className="i-ems-login-card">
          <div className="i-ems-login-logo">
            <LogoMark />
            <span className="i-ems-login-logo-wordmark">I-EMS Admin</span>
          </div>
          {sent ? (
            <Result
              status="success"
              title="Check your email"
              subTitle="If an account exists for that email, we've sent a password reset link. It expires in 30 minutes."
              extra={
                <Link to="/login">
                  <Button type="primary">Back to Sign in</Button>
                </Link>
              }
            />
          ) : (
            <>
              <Title level={3} className="i-ems-login-title">
                Forgot password?
              </Title>
              <div className="i-ems-login-subtitle">Enter your email and we'll send you a reset link.</div>
              <Form layout="vertical" onFinish={onFinish}>
                <Form.Item name="email" label="Email" rules={[{ required: true, type: "email" }]}>
                  <Input size="large" prefix={<MailOutlined style={{ color: "var(--i-ems-text-secondary)" }} />} placeholder="admin@company.com" />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type="primary" htmlType="submit" size="large" block loading={submitting}>
                    Send reset link <ArrowRightOutlined />
                  </Button>
                </Form.Item>
              </Form>
              <div className="i-ems-login-footnote">
                <Link to="/login">
                  <ArrowLeftOutlined /> Back to Sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
